import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  getters,
  
  actions: {
    add(state, item) {
      state.commit('add', item)
    },
    remove(state, item) {
      state.commit('remove', item)
    },
  
    /*申请直播流程中选择的资讯 -t*/
    addInfo(state, item) {
      state.commit('addInfo', item)
    },
    removeInfo(state, item) {
      state.commit('removeInfo', item)
    },
    /*申请直播流程中选择的资讯 -e*/
    /*申请直播流程中选择的资讯 -t*/
    addGoods(state, item) {
      state.commit('addGoods', item)
    },
    removeGoods(state, item) {
      state.commit('removeGoods', item)
    },
    /*申请直播流程中选择的资讯 -e*/
  }
});

export default store;
